import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;
const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const StreetService = {
    list: async (data) => axios.post(API_URL + "/street/list", data).then(({data}) => data).catch((err) => { throw err }),
    get: async (id) => axios.get(API_URL + `/getStreet/${id}`).then(({data}) => data).catch((err) => { throw err }),
    create: async (data) => axios.post(API_URL + `/street`, data).then(({data}) => data).catch((err) => { throw err }),
    edit: async (id, data) => axios.post(API_URL + `/street/${id}`, data).then(({data}) => data).catch((err) => { throw err }),
    destroy: async (id) => axios.delete(API_URL + `/street/${id}`).then(({data}) => data).catch((err) => { throw err }),
    importPreview: async (data) => axios.post(API_KEEPER + "/street/import/preview", data).then(({data}) => data).catch((err) => { throw err }),
    createImport: async (data) => axios.post(API_KEEPER + "/street/import", data).then(({data}) => data).catch((err) => { throw err }),
    importTemplateUrl: () => API_KEEPER + "/street/import/template",
    getAttendanceStreets: async (data) => axios.get(API_URL + "/locations/getAttendanceStreets").then(({data}) => data.map(d => ({value: d.id, label: d.text}))).catch((err) => { throw err }),
    streetNamesSchedule: async (data) => axios.get(API_URL + "/locations/streetNamesSchedule").then(({data}) => data.map(d => ({value: d.id, label: d.text}))).catch((err) => { throw err }),
    streetNames: async () => axios.get(API_URL + "/street/get/streetNames").then(({data}) => data.map(d => ({value: d.id, label: d.text}))).catch((err) => { throw err })
}

export default StreetService;
